import React from "react";
import style from "../../Styles/Components/Button.module.css";

const Button = ({ title, icon, color = "#ff7d40", height = 48, border= null, fontColor = null, onClick = ()=>{} }) => (
  <div onClick={onClick.bind(this)} className={style.container} style={{ backgroundColor: color, height, borderRadius: height/2, border }}>
    {icon ? <img className={style.icon} src={icon} alt="buttonIcon" /> : null}
    <span className={style.title} style={{color: fontColor}}>{title}</span>
  </div>
);

export default Button;

export const ButtonSNS = ({ title, icon, color = "#475993", height = 40, onClick = ()=>{} }) => (
  <div onClick={onClick.bind(this)} className={style.container} style={{ backgroundColor: color, height, borderRadius: height/2}}>
    {icon && <img className={style.icon} src={icon} alt="buttonIcon" />}
    <span className={style.titleSNS}>{title}</span>
  </div>
);
